import { render } from "./OurCoreServiceAboutUsMovility.vue?vue&type=template&id=79f15c6e&scoped=true"
import script from "./OurCoreServiceAboutUsMovility.vue?vue&type=script&lang=js"
export * from "./OurCoreServiceAboutUsMovility.vue?vue&type=script&lang=js"

import "./OurCoreServiceAboutUsMovility.vue?vue&type=style&index=0&id=79f15c6e&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79f15c6e"]])

export default __exports__